// rails-ujs is started by @activeadmin/activeadmin (imported in ../active_admin.js),
// so calling Rails.start() here too raises "rails-ujs has already been loaded!".

import * as ActiveStorage from '@rails/activestorage'
ActiveStorage.start()

import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }
